// extracted by mini-css-extract-plugin
module.exports = {"expanded":"SimpleTitle_expanded__2_bd5","collapsed":"SimpleTitle_collapsed__1Rwgj"};